import { Injectable } from '@angular/core';

import { AppLog } from '../../models';
import { BaseCRUDService } from '../base/base-crud.service';

@Injectable({
  providedIn: 'root',
})
export class AppLogsService extends BaseCRUDService<AppLog> {
  constructor() {
    super();

    this.endPoint = 'app/logs';
  }
}
